<template>
    <div>
        <sidebar-item
            :data-title="$t('message.sidebar.message.establishments')"
            :data-link="establishmentRedirectUrl"
            data-icon="mdi-store"
        ></sidebar-item>

        <sidebar-item
            :data-title="$t('message.sidebar.message.campaigns')"
            data-link="/campanhas"
            data-icon="mdi-store"
        ></sidebar-item>

        <sidebar-item
            :data-title="$t('message.sidebar.message.apsManagement')"
            :data-link="apsManagementRedirectUrl"
            data-icon="mdi-access-point"
        ></sidebar-item>

        <sidebar-toggle
            v-if="isWhitelabelScreensVisible || !isMarketingHidden"
            :title="$t('message.sidebar.message.platformCustomization')"
            icon="mdi-monitor-dashboard"
        >
            <sidebar-item
                v-if="isWhitelabelScreensVisible"
                :data-title="$t('message.sidebar.message.platformDomain')"
                :data-link="whitelabelDomainRedirectUrl"
                :disabled="!canUseWhitelabel"
                v-tooltip="{
                    content: !canUseWhitelabel
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="isWhitelabelScreensVisible"
                :data-title="$t('message.sidebar.message.platformScreens')"
                :data-link="whitelabelScreensRedirectUrl"
                :disabled="!canUseWhitelabel"
                v-tooltip="{
                    content: !canUseWhitelabel
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isMarketingHidden"
                :data-title="$t('message.sidebar.message.systemEmails')"
                data-link="/system-communications"
                :disabled="!canUseMarketingModule"
                v-tooltip="{
                    content: !canUseMarketingModule
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>
        </sidebar-toggle>

        <sidebar-toggle
            :title="$t('message.generics.message.settings')"
            icon="mdi-settings"
        >
            <sidebar-item
                :data-title="$t('message.generics.message.general')"
                :data-link="configGeneralRedirectUrl"
            >
            </sidebar-item>

            <sidebar-item
                data-title="Gerenciamento de Autenticação"
                :data-link="authManagamentRedirectUrl"
                :disabled="!canManageAuthentication"
                v-tooltip="{
                    content: !canManageAuthentication
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="canManageUsers"
                :data-title="$t('message.generics.message.users')"
                :data-link="configUsersRedirectUrl"
            >
            </sidebar-item>

            <sidebar-item
                :data-title="$t('message.settings.message.captiveEdit')"
                :data-link="registrationScreensRedirectUrl"
            ></sidebar-item>
        </sidebar-toggle>
    </div>
</template>

<script>
import SidebarItem from "@components/generic/sidebar/item/SidebarItem";
import SidebarToggle from "@components/generic/sidebar/toggle/SidebarToggle";
import provider from "@packages/mixins/provider";
import { redirectUtils } from "@packages/util/redirect/redirectUtils";

export default {
    components: {
        SidebarItem,
        SidebarToggle,
    },

    data() {
        return {};
    },
    mixins: [provider],

    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    computed: {
        permissions() {
            return this.user.permissions;
        },
        canManageUsers() {
            return (
                this.permissions.find((x) => x == "MANAGE_USERS") ||
                this.permissions.find((x) => x == "MASTER")
            );
        },
        canManageAuthentication() {
            return this.permissions.find((x) => x == "MANAGE_AUTHENTICATION");
        },
        canUseWhitelabel() {
            return this.permissions.includes("USE_WHITELABEL");
        },
        canUseMarketingModule() {
            return this.permissions.find((x) => x === "USE_MARKETING_MODULE");
        },
        isMarketingHidden() {
            return this.isDisabledModuleHidden("USE_MARKETING_MODULE");
        },
        isMaster() {
            return this.permissions.includes("MASTER");
        },
        hideDisabledModules() {
            return this.permissions.includes("HIDE_DISABLED_MODULES");
        },
        isWhitelabelScreensVisible() {
            return (
                this.isMaster && !this.isDisabledModuleHidden("USE_WHITELABEL")
            );
        },
        establishmentRedirectUrl() {
            return redirectUtils.mountUrl('/new/parceiro/estabelecimentos');
        },
        apsManagementRedirectUrl() {
            return redirectUtils.mountUrl('/new/parceiro/aparelhos');
        },
        configGeneralRedirectUrl() {
            return redirectUtils.mountUrl('/new/parceiro/configuracoes/geral');
        },
        configUsersRedirectUrl() {
            return redirectUtils.mountUrl('/new/parceiro/configuracoes/usuarios');
        },
        authManagamentRedirectUrl() {
            return redirectUtils.mountUrl('/new/parceiro/configuracoes/autenticacao');
        },
        whitelabelScreensRedirectUrl() {
            return redirectUtils.mountUrl('/new/parceiro/personalizacao/telas');
        },
        whitelabelDomainRedirectUrl() {
            return redirectUtils.mountUrl('/new/parceiro/personalizacao/dominio');
        },
        registrationScreensRedirectUrl() {
            return redirectUtils.mountUrl('/new/parceiro/configuracoes/cadastros/tela');
        },
    },

    methods: {
        isDisabledModuleHidden(permission) {
            return !this.permissions.includes(permission) && this.hideDisabledModules;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.sidebar {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    z-index: 1;
    background-color: white;
    justify-content: space-between;

    position: sticky;
    top: calc(13vh + 15px);

    @media (max-width: $desktop-md-max) {
        top: calc(15vh + 14px);
    }

    a {
        text-decoration: none;
    }

    .nav {
        width: 100%;
        padding-left: 0;

        // this is required to fill grid gap with white
        margin-top: -20px;
        padding-top: 20px;
        background-color: inherit;
    }
}
.custom-tooltip {
    margin-right: -325px;

    .tooltip-arrow {
        margin-left: -70px;
    }
}
</style>
